import { useEffect, useState } from 'react';

// O painel é uma SPA: quem abriu a aba antes de um deploy continua rodando o
// código antigo até recarregar — e vê a tela "de antes" achando que a entrega
// não chegou. Aqui o painel compara o próprio build com o /version.json
// publicado e avisa quando há versão nova.

const CHECK_MS = 60_000;

async function publishedBuild(): Promise<string | null> {
  try {
    const r = await fetch('/version.json', { cache: 'no-store' });
    if (!r.ok) return null;
    return ((await r.json()) as { build?: string }).build ?? null;
  } catch {
    return null;
  }
}

/** true quando o build publicado é diferente do que está rodando nesta aba. */
export function useNewVersion(): boolean {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    if (import.meta.env.DEV) return;
    let alive = true;
    const check = async () => {
      const b = await publishedBuild();
      if (alive && b && b !== __BZ_BUILD__) setStale(true);
    };
    void check();
    const id = window.setInterval(check, CHECK_MS);
    const onVis = () => { if (document.visibilityState === 'visible') void check(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { alive = false; window.clearInterval(id); document.removeEventListener('visibilitychange', onVis); };
  }, []);
  return stale;
}
